import { ValidatedOptions } from '@patternfly/react-core'

import type { Role } from '@app/domain/iam/user.interface'

export interface IUseValidatePinState {
  status?: ValidatePinStatusId
}

export enum ValidatePinStatusId {
  Default = 'default',
  Error = 'error',
  Success = 'success',
}

export type IUseValidatePinAction = (pin: string) => Promise<boolean>
export type IUseValidatePin = [ValidatePinStatusId, IUseValidatePinAction]

export interface UpdatePasswordResponse {
  status: string
}

export interface RetrieveAccountInfoResponse {
  userId: string
  email: string
  givenName: string
  familyName: string
  role?: Role
}

export const mapValidatePinStatus = (status: ValidatePinStatusId) => {
  switch (status) {
    case ValidatePinStatusId.Success:
      return ValidatedOptions.success
    case ValidatePinStatusId.Error:
      return ValidatedOptions.error
    default:
      return ValidatedOptions.default
  }
}
